import React, { useContext } from 'react';
import { CommentsContext, PreferenceContext, UserContext } from '../context';
import { DropDown, DropDownItem } from '../dropdown';
import { commentSortingOptions } from '../../data/sortings';
import { SortIconDown, SortIconUp } from 'icons';
import { gaEvent } from 'services/ga';

export const CommentsSorting = ({ menuRight }) => {
  const { user } = useContext(UserContext);
  const { setShowAllComments } = useContext(CommentsContext);
  const {
    preference: {
      sorting,
      sorting: { comments: commentsSort },
    },
    setPreference,
  } = useContext(PreferenceContext);

  const moderation = {
    label: 'Moderator',
    value: 'Moderator view',
  };
  const activeItem =
    commentsSort !== moderation.value
      ? commentSortingOptions().find((item) => item.value === commentsSort)
      : moderation.value;
  return (
    <DropDown
      label={
        commentsSort && activeItem
          ? commentsSort === moderation.value
            ? moderation.label
            : activeItem.label
          : 'sorteren'
      }
      isSelect
      iconProps={{
        Type: activeItem.direction === 'up' ? SortIconUp : SortIconDown,
      }}
      isRight={menuRight}
    >
      {commentSortingOptions(user && user.moderate).map((option) => (
        <DropDownItem
          label={option.value}
          key={option.value + option.direction}
          selectedValue={commentsSort === option.value}
          onClick={() => {
            gaEvent('dmp_comments', 'sort_' + option.value.replace(' ', '_').replace('-', '_'));
            setPreference({ sorting: { ...sorting, comments: option.value } });
            setShowAllComments(option.label === 'Moderator');
          }}
        />
      ))}
    </DropDown>
  );
};
